import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { Correction } from './correction.interface';

export class CorrectionService {
   async getCorrections(contractId: number, query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<Correction>>(`/contracts/${contractId}/corrections`, { params: { ...query } });
      return response.data;
   }
   async postCorrection(contractId: number, body: any) {
      return await http.post(`/contracts/${contractId}/corrections`, body).then((response) => response.data);
   }
   async putCorrection(contractId: number, correctionId: number, body: any) {
      throw Error('Method not implemented');
   }
   async deleteCorrection(contractId: number, correctionId: number) {
      return http.delete(`/contracts/${contractId}/corrections/${correctionId}`).then((response) => response.data);
   }
}
